import { Component, computed, effect, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { UserState } from '@core/state/user-state';
import { AuthService } from '@core/services/auth.service';
import { UserProfilePortalEndpoint } from '@core/api/services/user-profile-portal-endpoint';
import { CustomDialogService } from '../../services/custom-dialog.service';
import { LocalStorageService, STORAGE_KEYS } from '../../services/local-storage.service';
import { WelcomeVideoDialogComponent } from '../welcome-video-dialog/welcome-video-dialog.component';

@Component({
  standalone: true,
  selector: 'app-welcome-tour-dialog',
  imports: [],
  templateUrl: './welcome-tour-dialog.component.html'
})
export class WelcomeTourDialogComponent {
  private dialogRef = inject(DynamicDialogRef);
  private userState = inject(UserState);
  private authService = inject(AuthService);
  private storageService = inject(LocalStorageService);
  private customDialogService = inject(CustomDialogService);
  private userProfileEndpoint = inject(UserProfilePortalEndpoint);

  // the error interceptor hides dialog if opened
  private closeOnSessionLost = effect(() => {
    if (!this.authService.isAuthenticated()) {
      this.close();
    }
  });

  firstName = computed(() => this.userState.userProfileData()?.firstName ?? '');
  creditUnionName = computed(() => this.userState.creditUnionName() || 'your credit union');

  watchVideo() {
    this.close();
    this.customDialogService.openDialog(WelcomeVideoDialogComponent, {
      header: 'Getting Started with Credit Union Portal',
      width: 'min(90vw, calc((100vh - 200px) * 16 / 9))',
      breakpoints: { '640px': 'calc(100vw - 32px)' }
    });
    this.customDialogService.ref?.onClose.subscribe(() => this.userProfileEndpoint.completeOnboarding().subscribe());
  }

  skip() {
    this.storageService.set(STORAGE_KEYS.WELCOME_TOUR_SKIPPED, true);
    this.close();
  }

  dontShowAgain() {
    this.userProfileEndpoint.completeOnboarding().subscribe();
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
